import Handlebars from "hbs";
import TsInterpreter from "./tsInterpreter";
import TsApi from "./tsapi";
import BespokeFlipColourChange from "./bespokeFlipColourChange";
import SaLogin from "./saLogin";
//import PriceWidget from './priceWidget';

// ==================
// Templates
// ==================
import IntroSteps from "../../templates/components/intro-steps.html";
import ChooseYourDevice from "../../templates/components/choose-your-device.html";
import ChooseYourDeviceTVAV from "../../templates/components/choose-your-device-TVAV.html";
import Troubleshooter from "../../templates/components/troubleshooter.html";

//import TSCopyUKA from '../../copy/uk/troubleshooters.json';
/** Json file included for A/B testing **/
import TSCopyUKB from "../../copy/uk/troubleshooters-b.json";

import TSCopyIE from "../../copy/ie/troubleshooters.json";

import IntroCopyUK from "../../copy/uk/intro-steps.json";

import IntroCopyIE from "../../copy/ie/intro-steps.json";

import ErrorMessage from "../../copy/uk/error-messages.json";

import ConfirmPopup from "./confirmPopup";

import DABanners from "../../templates/components/da-banners.html";
import TVBanners from "../../templates/components/tv-banners.html";
import MobileBanners from "../../templates/components/mobile-banners.html";

import { getDevice } from "../util/util";

export default class Troubleshooters {
  constructor() {
    this.init();
    this.events();
  }

  init() {
    var $this = this;

    $this.TAG = "repairbooking";
    $this.templates = {};
    /** $this need to be changed **/

    $this.templates.introSteps = IntroSteps;
    $this.templates.chooseYourDevice = ChooseYourDevice;
    $this.templates.chooseYourDeviceTVAV = ChooseYourDeviceTVAV;
    $this.templates.troubleshooter = Troubleshooter;

    $this.templates.daBanners = DABanners;
    $this.templates.tvBanners = TVBanners;
    $this.templates.mobileBanners = MobileBanners;
    $this.urlDeviceModel = "";

    /** Product category section rendered by a component **/
    /** for P5 **/
    //$this.productCategoryCTA = '#product-category .s-marketing-cta .s-btn-cta';

    /** for P6 **/
    $this.productCategoryCTA = ".product-category .col.product";

    /* only for local environemt **/
    //$this.productCat = $this.getParam('cat');

    $this.isBespoke = $this.getParam("bespoke");

    // Mobile care anchor url
    $this.isMobileCareAnchorLink =
      document.URL.indexOf("#mobilecareplus") >= 0 ? true : false;

    window.state.apihost =
      window.location.host == "www.samsung.com"
        ? "https://samsung-support.cheil.london"
        : "https://samsung-support-stg.cheil.london";

    window.state.product = "";
    window.state.availableservice = "";
    window.state.ispmnotavailable = "";
    window.state.category = "";
    window.supportComponents.steps.setActiveStep(1);

    /** Updating Href attribute on AEM component **/
    /*** please check Both UK and IE sites still below line of coding is required***/

    if ($("#twentyeightdayscontact").length) {
      $("#twentyeightdayscontact .s-marketing-cta a").attr(
        "href",
        "tel:03330000333"
      );
    }

    if ($("#needtocontactus").length) {
      $("#needtocontactus .s-marketing-cta a[title$='0333 000 0333']").attr(
        "href",
        "tel:03330000333"
      );
    }

    $this.drawIntroSection();

    //console.log($this.isBespoke == "true");

    if ($this.isBespoke == "true" || $this.isMobileCareAnchorLink == true) {
      //$this.productCat = "mobile";

      //$this.showProductListForAEMComponents();
      window.addEventListener("load", (event) => {
        $(this.productCategoryCTA + "[data-cat=mobile]").trigger("click");
      });

      //showProductListForAEMComponents
    }

    $this.tsInterpreter = new TsInterpreter();

    if (window.location.host != "supportrepair.samsung.com") {
      $this.reloadThePageForState();
    } else {
      $("#top-banner .logout").show();
    }
    this.formatDeviceNameFromURL(window.location.href);
    var sku = "SM-" + $this.urlDeviceModel;
    let deviceBattery = getDevice(sku);
    // console.log(
    //   "urlDevice -> deviceBattery",
    //   deviceBattery,
    //   "urlDeviceModel",
    //   sku
    // );
    if (deviceBattery != "") {
      this.skipProductSelectionFromReplacment(deviceBattery);
    } else {
    }
  }

  privacyPopupUpdateListener(mutationList, observer) {
    mutationList.forEach(function (mutation) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        var stepsSummaryHeight = $(".steps-wrapper").outerHeight() + 20;
        stepsSummaryHeight += $(".summary-wrapper").is(":visible")
          ? $(".summary-wrapper").outerHeight()
          : 0;
        var scrollTop =
          $("#repair-booking-form").position().top - stepsSummaryHeight;

        $("html, body").animate(
          {
            scrollTop: scrollTop,
          },
          500,
          function () {}
        );
      }
    });
  }

  reloadThePageForState() {
    var $this = this;

    var saLogin = {};
    saLogin = new SaLogin();

    saLogin
      .isUserLoggedIn()
      .done(function (data) {
        if (window.state.isUserLoggedIn) {
          saLogin.getAccountDetails();

          if (saLogin.retriveState()) {
            if (window.state.isRedirectedToSALogin) {
              //window.state.revisitedAfterLogin = true;

              $this.productCat = window.state.category;
              $("#sa-login").hide();
              //console.log($this.productCat);

              if ($this.productCat != "") {
                if (window.state.selectedservice == "BESPOKE") {
                  $this.tsInterpreter.showBookingRepairForm();
                } else {
                  $('<div class="s-layer-dimmed"></div>').insertAfter(
                    "footer.footer"
                  );
                  $(".s-layer-dimmed").show();
                  $(".lds-ring1").show();

                  // Set this one to false to send the user to repair booking form
                  $this.tsInterpreter.lucidSuccess = false;
                  $(".steps-wrapper").addClass("show-steps");
                  $this.showProductListForAEMComponents();
                  // To show the form with respoective steps (PS, IH, IS)
                  $this.tsInterpreter.init();
                  $this.tsInterpreter.handleClickedContactUs();
                  var asList = window.state.availableservice.split("|");

                  // If we have both selectedservice Bespoke and available service > 1 then we take the previous state as Bespoke

                  if (asList.length > 1) {
                    $("#care-plus-repair").hide();
                    $this.tsInterpreter.drawRepairServiceSection(asList);

                    $this.tsInterpreter.handleClickedServiceType(
                      window.state.selectedservice
                    );
                  }

                  setTimeout(function () {
                    $("#continue-repair").trigger("click");
                  }, 500);

                  /** Code to observe privacy policy popup **/
                  const layerPrivacy = document.querySelector("#layerPrivacy");
                  const options = {
                    attributes: true,
                  };
                  const observer = new MutationObserver(
                    $this.privacyPopupUpdateListener
                  );
                  observer.observe(layerPrivacy, options);
                }
              }
            } else {
              $this.checkMyPageJourney();
            }
          }
        } else {
          $("#top-banner .logout").show();
          $("#top-banner .login").hide();
        }
      })
      .fail(function () {
        console.log("error");
      });
  }

  checkMyPageJourney() {
    var $this = this;

    var mypageRef = $this.getParam("reference");

    //console.log(mypageRef != '' && mypageRef !== undefined);

    if (mypageRef != "" && mypageRef !== undefined) {
      //Removing the reference get variable from the URL
      window.history.replaceState({}, document.title, window.location.pathname);
      var serialNumber = $this.getMypageSerialNumberByRef(mypageRef);
      $('<div class="s-layer-dimmed"></div>').insertAfter("footer.footer");
      $(".s-layer-dimmed").show();
      $(".lds-ring1").show();
    } else {
      $this.removeOverlay();
      console.log("Continue normal Journey");
    }
  }

  getMypageSerialNumberByRef(mypageRef) {
    var $this = this;

    var url = window.state.apihost + "/uk/repair-booking/repair-ref.php";
    var getProductDetailsForSerialNumberCount = 0;


    var form = new FormData();

    form.append("ref", mypageRef);

    var settings = {
      url: url,
      data: form,
      processData: false,
      contentType: false,
      dataType: "json",
      type: "POST",
    };

    $.ajax(settings)
      .done(function (response) {
        // console.log(response);
        if (response.success) {
          //$('.lds-ring2').show()
          var selectedMypageSerialNumber = response.productref;

          $this.getProductDetailsForSerialNumber(selectedMypageSerialNumber);
        } else {
          console.log("failed request for Ref");
          $this.removeOverlay();
        }
      })
      .fail(function () {
        console.log("failed request for Ref");
        $this.removeOverlay();
      });
  }

  getProductDetailsForSerialNumber(serialNumber) {
    var $this = this;

    var saDeviceList = window.digitalData.user.userDeviceList;
    //console.log(saDeviceList);

    //console.log(saDeviceList !== undefined && typeof saDeviceList === 'object' &&  saDeviceList.length > 0);
    //console.log(saDeviceList != "undefined" && typeof saDeviceList === 'object' &&  saDeviceList.length > 0);

    //console.log('Inside getProductDetailsForSerialNumber');

    var saProductDetail = [];

    if (
      saDeviceList !== undefined &&
      typeof saDeviceList === "object" &&
      saDeviceList.length > 0
    ) {
      //console.log('inside if');
      for (var deviceno = 0; deviceno < saDeviceList.length; deviceno++) {
        //console.log('inside for loop');

        var deviceDetail = saDeviceList[deviceno];

        if (
          $.trim(serialNumber) == $.trim(deviceDetail.deviceSerialNumberText)
        ) {
          saProductDetail.push({
            deviceModelID: deviceDetail.deviceModelID,
            deviceName: deviceDetail.deviceName,
            deviceSerialNumberText: deviceDetail.deviceSerialNumberText,
            deviceTypeCode: deviceDetail.deviceTypeCode,
            encImei: deviceDetail.encImei,
          });
          window.state._saProductDetail = saProductDetail;

          break;
        }
      }

      // If No maching product in Samsung account continue with normal journey
      if (saProductDetail.length > 0) {
        $this.skipProductSelectionForMypageProduct();
      } else {
        console.log("No maching product found on SA");
        $this.removeOverlay();
      }
    } else {
      setTimeout(function () {
        $this.getProductDetailsForSerialNumber(serialNumber);
      }, 500);
    }
  }

  skipProductSelectionForMypageProduct() {
    var $this = this;

    var category = "";
    var subcategory = "";
    var myPageCategory = window.state.saProductDetail[0].deviceTypeCode;
    var deviceModel = window.state.saProductDetail[0].deviceModelID;
    var galaxyBookModelsMappedToTablets = [
      "SM-W728NZKABTU",
      "SM-W720NZKABTU",
      "SM-W720NZKAXSA",
      "SM-W720NZKBBTU",
      "SM-W720NZKBXAR",
      "SM-W720NZKBXSA",
      "SM-W723NZKAXAR",
      "SM-W727VZKBVZW",
      "SM-W727YZKBTEL",
      "SM-W727YZKBXSA",
      "SM-W728YZKATEL",
      "SM-W728YZKAXSA",
    ];

    switch (myPageCategory) {
      case "Phone":
        category = "mobile";
        subcategory = "Smartphones";
        break;
      case "Tablet":
      case "Tablets":
        if (galaxyBookModelsMappedToTablets.includes(deviceModel)) {
          category = "itrepair";
          subcategory = "Galaxy Book";
        } else {
          category = "mobile";
          subcategory = "Tablets";
        }
        break;
      case "Watch":
      case "Buds":
      case "Earbuds":
        category = "mobile";
        subcategory = "Wearables";
        break;
      case "Galaxy Book":
      case "Computer":
        // Note PCs are raised repair request under Tablets
        /**if (deviceModel.startsWith("NP")) {
                    category = 'mobile';
                    subcategory = 'Tablets';
                } else{

                }**/
        category = "itrepair";
        subcategory = "Galaxy Book";
        break;
      case "Monitor":
        category = "itrepair";
        subcategory = "Monitor";
        break;
      case "Projector":
        category = "tvav";
        subcategory = "Projector";
        break;
      case "Home audio device":
      case "AV":
        category = "tvav";
        subcategory = "AV";
        break;
      case "Refrigerator":
        category = "homeappliance";
        subcategory = "Refrigerator";
        break;
      case "Laundry":
      case "Dryer":
      case "Washer":
      case "AirDresser":
        category = "homeappliance";
        subcategory = "Laundry";
        break;
      case "Dishwasher":
      case "Dishwashers":
        category = "homeappliance";
        subcategory = "Dishwashers";
        break;
      case "Microwave":
      case "Hob":
      case "Oven":
        category = "homeappliance";
        subcategory = "Cooking";
        break;
      case "Vacuum cleaner":
      case "Vacuum Cleaners":
        category = "homeappliance";
        subcategory = "Vacuum Cleaners";
        break;
      case "TV":
        category = "tvav";
        //subcategory = "TV";
        if (
          deviceModel.includes("SP-LSP3") ||
          deviceModel.includes("SP-LSP7") ||
          deviceModel.includes("SP-LSP9")
        ) {
          subcategory = "Projector";
        } else {
          subcategory = "TV";
        }
        break;
      default:
        category = $this.toTitleCaseNoSpace(myPageCategory);
        subcategory = "UnSupported";
        break;
    }

    var categoriesNotSupported = Object.keys(ErrorMessage);

    // console.log('Category', category);
    $this.removeOverlay();

    if (categoriesNotSupported.indexOf(category) != -1) {
      // console.log(ErrorMessage[category].url,'ErrorMessage')
      //$('.lds-ring1').hide()

      var confirmPopup = new ConfirmPopup(
        ErrorMessage[category].text,
        ErrorMessage[category].url
      );

      confirmPopup.showConfirmPopup();
      confirmPopup.setRedirectOnClose(true);
    } else {
      //$('.lds-ring2').hide()

      if (category != "") {
        $($this.productCategoryCTA + '[data-cat="' + category + '"]').trigger(
          "click"
        );
      }

      if (subcategory != "") {
        $(
          '#products-container .product[data-product="' + subcategory + '"]'
        ).trigger("click");

        switch (subcategory) {
          case "Smartphones":
          case "Tablets":
          // case "Wearables":
          case "Projector":
          case "AV":
          case "Vacuum Cleaners":
            $this.redirectIframe(
              window.state.saProductDetail[0].deviceModelID,
              subcategory
            );
            break;
        }
      }
    }
  }

  skipProductSelectionFromReplacment(deviceBattery) {
    var $this = this;
    var category = "mobile";
    var subcategory = "Smartphones";
    var categoriesNotSupported = Object.keys(ErrorMessage);

    $this.removeOverlay();

    if (categoriesNotSupported.indexOf(category) != -1) {
      var confirmPopup = new ConfirmPopup(
        ErrorMessage[category].text,
        ErrorMessage[category].url
      );

      confirmPopup.showConfirmPopup();
    } else {
      let device = this.urlDeviceModel;

      if (device != "") {
        let tsUrl = `https://samcustdotcom.likewizesupport.com//sam/s/device/Samsung/${deviceBattery}/`;
        $(".product-category .col.product[data-cat='mobile']").addClass(
          "active"
        );
        $(".product-category .col.product").addClass("img-txt");
        $(".steps-wrapper").addClass("show-steps");
        window.state.category = category;
        window.state.product = subcategory;
        window.state.availableservice = "PS|DSR|ISR";
        window.state.ispmnotavailable = false;
        this.drawTroubleshootingGuide(tsUrl);
      } else {
        var confirmPopup = new ConfirmPopup(
          ErrorMessage["AV"].text,
          ErrorMessage["AV"].url
        );
        confirmPopup.showConfirmPopup();
        confirmPopup.setRedirectOnClose(true);
      }
    }
  }

  formatDeviceNameFromURL(url) {
    var $this = this;
    const queryParams = new URLSearchParams(url.split("?")[1]);
    let deviceName = queryParams.get("device");
    if (deviceName == null) {
      return;
    }
    deviceName = deviceName.replace(/[^a-zA-Z0-9]/g, "");
    $this.urlDeviceModel = deviceName;
  }

  removeOverlay() {
    if ($(".s-layer-dimmed").length > 0) {
      $(".s-layer-dimmed").hide();
      $(".s-layer-dimmed").remove();
      $(".lds-ring1").hide();
    }
  }

  redirectIframe(sku, subcategory) {
    let device = getDevice(sku);

    if (device != "") {
      this.loadiFrame(
        `https://samcustdotcom.likewizesupport.com/sam/s/device/Samsung/${device}/`
      );
    }

    if (device == "" && subcategory == "AV") {
      var confirmPopup = new ConfirmPopup(
        ErrorMessage["AV"].text,
        ErrorMessage["AV"].url
      );
      confirmPopup.showConfirmPopup();
      confirmPopup.setRedirectOnClose(true);
    }
  }

  toTitleCaseNoSpace(str) {
    return str
      .replace(/(?:^|\s)\w/g, function (match) {
        return match.toUpperCase();
      })
      .split(" ")
      .join("");
  }

  resetProductCategoryState() {
    window.state.category = "";
    this.resetProductState();
  }

  resetProductState() {
    window.state.product = "";
    window.state.availableservice = "";
    window.state.ispmnotavailable = "";
    window.state.selectedservice = "";
    window.state.availableservice = "";
  }

  events() {
    var $this = this;

    if ($(this.productCategoryCTA).length) {
      $(this.productCategoryCTA)
        .off("click")
        .on("click", function (e) {
          e.preventDefault();
          $(".product-category .col.product").removeClass("active");
          $(".product-category .col.product").addClass("img-txt");
          $(this).addClass("active");

          $(".product-category .rows").addClass("no-top-padding");

          $this.productCat = $(this).attr("data-cat");

          $(".steps-wrapper").addClass("show-steps");

          $this.resetToProductCategoryLevel();

          $this.showProductListForAEMComponents();

          if (
            $("#repair-solutions").hasClass("rows-grid-4") ||
            $("#repair-solutions").hasClass("rows-grid-3") ||
            $("#repair-solutions").hasClass("rows-grid-2") ||
            $("#repair-solutions").hasClass("rows-grid-1")
          ) {
            $("#repair-solutions")
              .removeClass("rows-grid-4")
              .removeClass("rows-grid-3")
              .removeClass("rows-grid-2")
              .removeClass("rows-grid-1");
          }

          if ($("#general-repair-steps")) {
            $("#general-repair-steps").hide();
          }

          // reset pickup map
          if ($('.store-locator__search').val() != '') {
            $('.store-locator__search').val('')
            $(".sl-wrapper-inner").hide();
          }

          // reset POP
          if (window.state._popJourney.length >=1 || window.state.proofOfPurchase) {
            window.state._popJourney = []
            delete window.state.proofOfPurchase
          }
        });
    }

    /*$('#price-repair-widget .btn-container .s-btn-cta').off('click').on('click', function(){

            $('#product-category .s-marketing-cta a.s-btn-cta[href$="#mobile"]').trigger('click');

        });*/

    /*$('#products-container .product').off('click').on('click', function(e) {

            e.preventDefault();
            $(this).find('a').trigger('click');

        });
*/

    $("#products-container .product")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $(".alt-troubleshooter-txt").hide();
        $("#dsr-surcharge-txt").hide();

        $("#troubleshooting-guide").html("");
        $("#repair-solutions").html("");
        $("#care-plus-repair").hide();

        //$('#bespoke-flip-banner').hide();
        $("#sa-login").hide();
        // $('#sa-login  .banner-wrapper').hide();
        // $('#sa-login #sa-login-back-btn').hide();

        $("#confirmSelection").hide();
        $("#placeOfPurchase").trigger("reset");
        window.sprChat("close");
        //$('#bespoke-flip-banner').hide();
        $("#cheil-static-app").hide();

        $(".repair").hide();
        $("#products-section").show();

        /** To revert back previous selections **/
        $this.resetTroubleshooterJourney();
        $this.resetProductState();

        var product = $(this).data("product");
        var tsUrl = $(this).data("lucidurl");
        var isTSApiAvailable = $(this).data("istsapiavailable");
        var productImage = $(this).data("prductimage");
        var availableService = $(this).data("availableservice");
        var ispmnotavailable = $(this).data("ispmnotavailable");

        /*$("#products-container .product a").removeClass('selected');
            $(this).addClass('selected');*/

        //If the product element clicked set isBespoke to false to not take the user to Bespoke banner
        //$this.isBespoke = "false";

        if (tsUrl != "" || isTSApiAvailable) {
          $this.resetTroubleshooterJourney();
          window.state.product = product;
          window.state.availableservice = availableService;
          window.state.ispmnotavailable = ispmnotavailable;
          window.state.productImage = productImage;

          // window.supportComponents.faq.setCategory('Smartphone');
          var faqLinkCat = product.replace(/ /g, "");
          /** faqLinkCat = faqLinkCat.replace('Smartphones', 'Smartphone');
                faqLinkCat = faqLinkCat.replace('Tablets', 'Tablet');
                faqLinkCat = faqLinkCat.replace('Wearables', 'Wearable');
                faqLinkCat = faqLinkCat.replace('Projector', 'Projectors');
                faqLinkCat = faqLinkCat.replace('Smartphones', 'Smartphone');
                faqLinkCat = faqLinkCat.replace('Refrigerator', 'Refrigeration');**/

          //console.log(faqLinkCat);
          if (site == "uk") {
            $("support-faq").attr("category", faqLinkCat);
            window.supportComponents.faq.setCategory(faqLinkCat);
            $("support-faq").css("display", "block");
            $("support-faq").attr("open", false);
          }
          $(".floating-navigation").addClass("floating-navigation--fixed");

          if (isTSApiAvailable) {
            console.log('checking uk ie')
            var tsApi = new TsApi(product);

            //$this.drawTroubleshootingGuide(tsUrl);
          } else {
            $this.drawTroubleshootingGuide(tsUrl);
          }
        } else {
          var product = $(this).data("product");

          if (product == "Computing Accessories") {
            $("#alt-troubleshooter-txt").show("slow");
          } else if (product == "Harman JBL and AKG devices") {
            $("#harman-jbl-akg").css("display", "flex");
          }
        }
      });

    $("#harman-jbl-akg .product")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        var redirectURL = $(this).data("redirecturl");
        window.location.href = redirectURL;
      });

    $("#productBack")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $this.scrollTo("#choose-your-product");
        $this.resetToProductCategoryLevel();
        $this.resetTroubleshooterJourney();
        $("#products-section").hide();
        $("#mobile-care-banner").hide();
        // $('#bespoke-banner').hide();
        // $('#screen-repair-banner').hide();
        window.supportComponents.steps.setActiveStep(1);
      });

    /** Care plus banner continue button click event **/
    $("#care-plus-continue").on("click", function (e) {
      e.preventDefault();
      $("#bespoke-model-selector").hide();
      $("#cheil-static-app").show();
      $(".btn-hide a").hide();
      $this.scrollTo("#cheil-static-app");
    });

    $("#products-section .get-in-touch").on("click", function (e) {
      e.preventDefault();
      //$this.scrollTo('#other-solutions-section');
      $this.scrollTo("#contactus");
    });
  }

  showFourColBanners() {
    var $this = this;

    $(".four-col-banner-wrapper").html("");

    if ($this.productCat == "mobile") {
      var source = $this.templates.mobileBanners;
      var template = Handlebars.compile(source);
      var compiled = template({});

      $(".four-col-banner-wrapper").html(compiled);
      $(".four-col-banner-wrapper").show();

      if (site == "uk") {
        const bespokeFlipColourChange = new BespokeFlipColourChange();
      }

      //To initiate the Smaung care CTA events
      $this.events();
    } else if (
      $this.productCat == "tvav" ||
      $this.productCat == "homeappliance"
    ) {
      // var source = ($this.productCat == 'homeappliance') ? $this.templates.daBanners : $this.templates.tvBanners;
      var source = $this.templates.daBanners;
      var template = Handlebars.compile(source);
      var compiled = template({});

      $(".four-col-banner-wrapper").show();

      $(".four-col-banner-wrapper").html(compiled);
    } else {
      $(".four-col-banner-wrapper").hide();
    }
  }

  resetToProductCategoryLevel() {
    var $this = this;

    // If the category is set by the reference from Mypage, reset the product details if the user changes the category after reaching repair page
    if (window.state.category != "") {
      window.state._saProductDetail = [];
    }

    $("#troubleshooting-guide").html("");
    $("#repair-solutions").html("");
    $("#care-plus-repair").hide();
    $("#repair_summary").hide();

    $("#sa-login").hide();
    // $('#sa-login  .banner-wrapper').hide();
    // $('#sa-login #sa-login-back-btn').hide();
    $("#bespoke-model-selector").hide();

    $("#confirmSelection").hide();
    $("#placeOfPurchase").trigger("reset");
    window.sprChat("close");

    $(".repair").hide();
    $this.resetTroubleshooterJourney();
    $this.resetProductCategoryState();
    $this.reSetRepairSummary();

    $(".confirm-wrapper").html("");
    $(".confirm-wrapper").hide();
    $(".thankyou-wrapper").html("");
    $(".thankyou-wrapper").hide();

    /** Hide Flip bespoke colour selector when Product category is selected **/
    $(".bespoke-flip-colour-picker-wrapper").hide();
  }

  reSetRepairSummary() {
    $("#repair_summary").attr("device-name", "");
    $("#repair_summary").attr("reference-number", "");
    $("#repair_summary").attr("repair-type", "");
    $("#repair_summary").attr("repair-description", "");
    $("#repair_summary").attr("appointment-date", "");
    $("#repair_summary").attr("appointment-time", "");
    $("#repair_summary").attr("appointment-location", "");
    $("#repair_summary").attr("appointment-type", "");
  }

  resetTroubleshooterJourney() {
    /** Show the map when the class is initialise from troubleshooter **/
    $(".sl-selector-start").show(1);
    $(".sl-appointment-start").hide(1);

    /** P6 AEM comoponents **/
    $("#mobile-door-step-repair-steps").hide();
    $("#pickup-repair-steps").hide();
    $("#ha-pickup-repair-steps").hide();
    $("#mobile-instore-repair-steps").hide();
    $("#in-home-repair-steps").hide();
    $("#ps-in-home-repair-steps").hide();
    $("#kiss-in-home-repair-steps").hide();
    $("#doorsteprepaircta").hide();
    $("#dsr-surcharge-txt").hide();
    $("#twentyeightdayscontact").hide();
    $("#bespoke-model-selector").hide();

    $("#support-faq").hide();

    /** Reset the state **/
    //window.state.selectedservice = '';
  }

  showProductListForAEMComponents() {
    var $this = this;

    if (typeof this.productCat == "string" && this.productCat !== undefined) {
      $("#screen-repair-banner").hide();
      //$('#price-repair-widget').hide();
      $("#content").removeClass(
        "mobile-tablet homeappliance tvav itrepair floorcare"
      );
      $("#troubleshooting-guide").hide();
      $("#bespoke-flip-banner").hide();
      //$('#which-banner').hide();
      this.resetTroubleshooterJourney();

      $("#additional-help").show();

      /** Add product category to state for Repair form **/
      window.state.category = this.productCat;

      switch (this.productCat) {
        case "mobile":
          $("#content").addClass("mobile-tablet");
          //$('#screen-repair-banner').show();
          //$('#bespoke-flip-banner').show();
          this.initSamsungCareConfirmPopup();
          /** This resize action to triggered to fix the Klarna and trade in CTA's overlapping with banner (AEM components) **/
          $(window).trigger("resize");
          break;

        case "homeappliance":
          $("#content").addClass("homeappliance");
          //$('#which-banner').show();
          $("#cheil-static-app").hide();
          /** This resize action to triggered to fix the Which banner CTA's overlapping with banner (AEM components) **/
          $(window).trigger("resize");
          break;

        case "tvav":
          $("#content").addClass("tvav");
          //$('#which-banner').show();
          $("#cheil-static-app").hide();
          break;

        case "itrepair":
          $("#content").addClass("itrepair");
          $("#cheil-static-app").hide();
          break;
      }

      $("#products-section").show();

      this.drawProductSection(this.productCat);

      window.supportComponents.steps.setActiveStep(1);
      //$('#repair-options').hide();

      $this.showFourColBanners();
      $this.initSlick();

      /** If Bespoke service **/

      if ($this.isBespoke == "true") {
        if (!$(".floating-navigation").hasClass("floating-navigation--fixed")) {
          $(".floating-navigation").addClass("floating-navigation--fixed");
        }

        setTimeout(function () {
          $("#bespoke-banner .btn-container a").trigger("click");
        }, 500);
        $this.isBespoke = "false";
      } else if ($this.isMobileCareAnchorLink == true) {
        if (!$(".floating-navigation").hasClass("floating-navigation--fixed")) {
          $(".floating-navigation").addClass("floating-navigation--fixed");
        }

        // $('#care-plus-continue').trigger('click');
        setTimeout(function () {
          //$('#care-plus-anchor-link').show();
          /** This Anchor link event is setup on bespokeFlipColourChange.js file **/
          $("#care-plus-continue").trigger("click");
        }, 500);

        $this.isMobileCareAnchorLink = false;
      } else {
        $this.scrollTo(".floating-navigation");
      }

      var arr = $(".cheil-static img")
        .map(function () {
          return this.src;
        })
        .get();
    }
  }

  initSamsungCareConfirmPopup() {
    $("#cheil-static-app a").on("click", function (event) {
      var popupCtaUrl = $(this).attr("href");

      if (popupCtaUrl != "") {
        if (!popupCtaUrl.includes("tel:")) {
          event.preventDefault();
          var popupText =
            "You will now be directed to our insurance policy partner website.";
          var confirmPopup = new ConfirmPopup(popupText, popupCtaUrl);
          confirmPopup.showConfirmPopup();
        }
      }
    });
  }

  drawIntroSection() {
    var introCopy = this.introCopy();

    //console.log(introCopy);

    $("#intro-copy").html("");

    var source = this.templates.introSteps;
    var template = Handlebars.compile(source);
    var compiled = template({
      introCopy: introCopy,
    });

    $("#intro-copy").html(compiled);
  }

  drawProductSection(selectedProduct) {
    var tsCopy = this.troubleshootersCopy();
    
    $("#products-section").html("");
    
    this.productCopy = tsCopy[selectedProduct][0];

    var source = "";

    if (selectedProduct == "tvav" && site == "uk") {
      source = this.templates.chooseYourDeviceTVAV;
      this.tsInterpreter.tvavExtra();
    } else {
      source = this.templates.chooseYourDevice;
    }

    var template = Handlebars.compile(source);
    var compiled = template({
      productCopy: this.productCopy,
      site: site === "ie" ? true : false,
    });

    $("#products-section").show();

    $("#products-section").html(compiled);

    /* if(this.productCopy.categories.length > 3) {

            this.initSlick();

        }*/

    this.events();
  }

  drawTroubleshootingGuide(tsUrl) {
    var source = this.templates.troubleshooter;
    var template = Handlebars.compile(source);
    var compiled = template({
      productCopy: this.productCopy,
    });

    $("#troubleshooting-guide").html(compiled);

    $("#products-section").hide();

    $("#troubleshooting-guide").show();

    window.supportComponents.steps.setActiveStep(2);

    this.scrollTo("#troubleshooting-guide");

    this.loadiFrame(tsUrl);

    this.events();
  }

  loadiFrame(iframeUrl) {
    var $this = this;
    var url = "";

    var date = new Date();
    var url = iframeUrl + "?ts1=" + date.getTime();
    $(".lucid #iframe-state").text("Loading...");
    $("#iframe").attr("src", "");
    $("#iframe").attr("src", url);

    this.tsInterpreter.init();
    // $('#iframe').contentWindow.location.reload(true);
  }

  setApiHostByServerMigrationFlag() {
    var $this = this;
    window.state.apihost =
      window.location.host == "www.samsung.com"
        ? "https://samsung-support.cheil.london"
        : "https://samsung-support-stg.cheil.london";
    var url =
      "https://samsung-repair-prices.s3.eu-west-2.amazonaws.com/repair-form/";
    var fileName =
      window.location.host == "www.samsung.com"
        ? "server-flag-live.json"
        : "server-flag.json";
    var cacheBustor = Math.floor(Math.random() * 1000000000);
    fileName = fileName + "?v=" + cacheBustor;
    url = url + fileName;

    $.get(url, function (data) {
      //$this.doLog(data);
      //console.log(data);

      if (!data.use_aws_server) {
        window.state.apihost =
          window.location.host == "www.samsung.com"
            ? "https://sebnapi.nl"
            : "https://sebnapi.sebnstaging.nl";
      }

      // $this.doLog(window.state.islockersflagon);

      //console.log(window.state.apihost);
    }).done(function () {});
  }

  scrollTo(elem) {
    var stepsSummaryHeight = $(".floating-navigation").hasClass(
      "floating-navigation--fixed"
    )
      ? $(".steps-wrapper").outerHeight()
      : 0;

    stepsSummaryHeight += $(".summary-wrapper").is(":visible")
      ? $(".summary-wrapper").outerHeight()
      : 0;

    var scrollTop = $(elem).position().top - stepsSummaryHeight;

    setTimeout(function () {
      $("html, body").animate(
        {
          scrollTop: scrollTop,
        },
        100,
        function () {}
      );
    }, 500);
  }

  getParam(param) {
    var pageURL = window.location.search.substring(1);
    var URLVariables = pageURL.split("&");

    // main.doLog('Query string values:');

    for (var i = 0; i < URLVariables.length; i++) {
      var queryString = URLVariables[i].split("=");

      // main.doLog('Key: ' + queryString[0] + ', Value:  ' + queryString[1]);

      if (queryString[0] == param) {
        return queryString[1];
      }
    }
  }

  introCopy() {
    return site == "uk" ? IntroCopyUK : IntroCopyIE;
  }

  troubleshootersCopy() {
    return site == "uk" ? TSCopyUKB : TSCopyIE;
  }

  initSlick() {
    // Check and remove the fourth child from #datv-banners
    if (document.querySelector("#datv-banners div:nth-child(4)")) {
      document.querySelector("#datv-banners div:nth-child(4)").remove();
    }

    setTimeout(function () {
      // Initialize slick for four-col-banner-wrapper
      $(".four-col-banner-wrapper .fcbw__row").each(function() {
        var isMobileBanners = $(this).closest('#mobile-banners').length > 0;
        var slidesToShowValue = isMobileBanners ? 4 : 3;

        $(this).slick({
          // normal options...
          infinite: false,
          slidesToShow: slidesToShowValue, // dynamic value
          dots: false,

          responsive: [
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 4,
              },
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: true,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
              },
            },
          ],
        });
      });
    }, 500);
}

}
